import React, { ChangeEvent } from 'react';

import {
  GadgetFormInner,
  GadgetFormInnerContent,
  GadgetFormWrapper,
} from '../V5GadgetForm/V5GadgetForm';
import Typography from 'kingpin/atoms/Typography';
import { Section } from '../MyAccount/Profile/styles';
import Inputs from '../Inputs';
import PeerGroupInput from './PeerGroupInput';
import EntityInput from './EntityInput';

const GaugeForm = ({
  // Base
  name,
  onNameChanged,
  description,
  onDescriptionChanged,
  metricId,
  setMetricId,
  metricDisplayName,
  onMetricDisplayNameChanged,
  setMetricDisplayName,
  //   Gauge
  peerGroup,
  setPeerGroup,
  entity,
  setEntity,
  // Misc
  isValid,
  isLoading,
  draftGauge,
  isReversed,
  setIsReversed,
}: {
  // Base
  name: string;
  onNameChanged: (event: ChangeEvent<HTMLInputElement>) => void;
  description: string;
  onDescriptionChanged: (event: ChangeEvent<HTMLInputElement>) => void;
  metricId?: string;
  setMetricId: React.Dispatch<React.SetStateAction<string | undefined>>;
  metricDisplayName: string;
  onMetricDisplayNameChanged: (event: ChangeEvent<HTMLInputElement>) => void;
  setMetricDisplayName: React.Dispatch<React.SetStateAction<string>>;
  //   Gauge
  peerGroup?: string;
  setPeerGroup: React.Dispatch<React.SetStateAction<string | undefined>>;
  entity?: string;
  setEntity: React.Dispatch<React.SetStateAction<string | undefined>>;
  // Misc
  isValid: boolean;
  isLoading: boolean;
  draftGauge?: VisualisationDefinitions.Gauge;
  isReversed: boolean;
  setIsReversed: React.Dispatch<React.SetStateAction<boolean>>;
}) => (
  <GadgetFormWrapper>
    <GadgetFormInner isGadgetBuilder={false}>
      <GadgetFormInnerContent isGadgetBuilder={false}>
        {/* Base */}
        <Section>
          <Typography.Body type="Label">Name</Typography.Body>
          <Inputs.TextInput
            placeholder="Name"
            value={name}
            onChange={onNameChanged}
          />
        </Section>
        <Section>
          <Typography.Body type="Label">Description</Typography.Body>
          <Inputs.TextInput
            placeholder="Name"
            value={description}
            onChange={onDescriptionChanged}
          />
        </Section>
        <Section>
          <Typography.Body type="Label">Metric</Typography.Body>
          <Inputs.MetricPicker
            metricId={metricId}
            setMetricId={setMetricId}
            noSpecials
            setMetricDisplayName={setMetricDisplayName}
          />
        </Section>
        <Section>
          <Typography.Body type="Label">Metric Display Name</Typography.Body>
          <Inputs.TextInput
            value={metricDisplayName}
            onChange={onMetricDisplayNameChanged}
            placeholder="Display name"
          />
        </Section>
        {/* Gauge */}
        <Section>
          <Typography.Body type="Label">Peer Group</Typography.Body>
          <PeerGroupInput
            peerGroup={peerGroup}
            setPeerGroup={setPeerGroup}
            metricId={metricId}
            setEntity={setEntity}
          />
        </Section>
        <Section>
          <Typography.Body type="Label">Entity</Typography.Body>
          <EntityInput
            peerGroup={peerGroup}
            metricId={metricId}
            entity={entity}
            setEntity={setEntity}
          />
        </Section>
        <Section>
          <Typography.Body type="Label">Is reversed</Typography.Body>
          <Inputs.Toggle value={isReversed} onChange={setIsReversed} />
        </Section>
      </GadgetFormInnerContent>
    </GadgetFormInner>
  </GadgetFormWrapper>
);

export default GaugeForm;
